import styled from 'styled-components'
import { Button, Container, Icon } from 'components/atoms'

export const Root = styled(Container)`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 0;
`

export const SearchIcon = styled(Icon)`
  font-size: 48px;
  color: ${ (props) => props.theme.colors['icon-grau2'] };
  margin-bottom: 20px;
`

export const InfoText = styled.span`
  font-size: 24px;
  font-weight: 300;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.21;
  letter-spacing: normal;
  text-align: center;
  margin-bottom: 30px;
`

export const LinkButton = styled(Button).attrs(() => ({
  className: 'btn-link',
}))`
  color: ${ (props) => props.theme.colors['standard-schwarz'] };
  text-decoration: underline;
  margin-bottom: 15px;
  cursor: pointer;
  width: auto;
  text-align: center;
`
